export default __webpack_public_path__ + "static/media/fridge1-before1-480w.e3ce8e94.webp";